// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import axios from "axios";

// const AdminRoute = ({ children }) => {
//   const [loading, setLoading] = useState(true);
//   const [isAdmin, setIsAdmin] = useState(false);

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     if (!user) {
//       setLoading(false);
//       setIsAdmin(false);
//       return;
//     }

//     // Verify role from database
//     axios
//       .get(`http://localhost:8080/api/auth/me?email=${user.email}`)
//       .then((res) => {
//         if (res.data.role === "ADMIN") setIsAdmin(true);
//         setLoading(false);
//       })
//       .catch(() => {
//         setIsAdmin(false);
//         setLoading(false);
//       });
//   }, []);

//   if (loading) return <p>Loading...</p>;

//   if (!isAdmin) return <Navigate to="/login" replace />;

//   return children;
// };

// export default AdminRoute;


import { Navigate } from "react-router-dom";

export default function AdminRoute({ children }) {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== "ADMIN") {
    return <Navigate to="/" replace />;
  }

  return children;
}




